/*
 * Copyright (c) 2021 LucidResolutions LLC. All rights reserved.
 */

import React, {createContext, useEffect, useState} from "react";
import AuthService from "../service/auth.service";

let isUserActive = true
function setIsUserActive(val){
    isUserActive = val
}

const AuthContext = createContext({
    token: null,
    userStatus: true,
    setToken: (val) =>{},
    setIsUserActive: (val) =>{}
})

const svc = new AuthService()
const AuthServiceProvider = (props) =>{
    const [token, setToken] = useState(svc.hasToken() && svc.getToken());
    const [userStatus, setUserStatus] = useState(isUserActive)

    const onSetToken = (t) =>{
        svc.setToken(t)
        setToken(t)
    }

    useEffect(()=>{
        let id = setInterval(()=>{
            setUserStatus(isUserActive)
        }, 1000)

        return ()=>{
            clearInterval(id)
        }
    })

    return (
        <AuthContext.Provider value={{
            token: token,
            setToken: onSetToken,
            userStatus: userStatus,
        }}>
            {props.children}
        </AuthContext.Provider>
    )

}


export {AuthContext, AuthServiceProvider, setIsUserActive}
